<div class="header" [class.has-subnav]="showProductSubnav">
  <header class="primary-bar d-flex flex-wrap align-items-center justify-content-between py-2 px-4">
    <div class="d-flex align-items-center gap-3">
      <a href="/" class="d-inline-flex link-body-emphasis text-decoration-none" (click)="goHome(); $event.preventDefault()">
        <img src="../../assets/images/landing/GeoAstra_logo_Transparent_black_Colors_1300x300.png" width="180" height="42" alt="GeoAstra Logo">
      </a>

      <!-- Mobile menu -->
      <button class="rail-toggle d-inline-flex d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#landingNav" aria-controls="landingNav" aria-label="Menu">
        <span class="material-icons">menu</span>
      </button>
    </div>

    <!-- Desktop primary nav -->
    <ul class="nav primary-nav d-none d-lg-flex align-items-center mb-0">
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Software and Service</a>
        <ul class="dropdown-menu">
          <li><button class="dropdown-item" type="button" (click)="openNtrip()">NTRIP Caster</button></li>
          <li><a class="dropdown-item" [href]="rtkExpertSiteUrl || 'https://rtk-expert.geoastra.com'">RTK Expert</a></li>
          <li><button class="dropdown-item" type="button" (click)="openSoftwareProduct('software-ble-gnss')">BLE-GNSS iOS App</button></li>
          <li><hr class="dropdown-divider"></li>
          <li><button class="dropdown-item" type="button" (click)="openSoftware()">All software and service</button></li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">GNSS Hardware</a>
        <ul class="dropdown-menu">
          <li *ngFor="let r of receiverLinks">
            <button class="dropdown-item" type="button" (click)="openReceiver(r.anchor)">{{ r.label }}</button>
          </li>
          <li><hr class="dropdown-divider"></li>
          <li><button class="dropdown-item" type="button" (click)="openReceivers()">All receivers</button></li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Docs</a>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" href="https://community.geoastra.com/documents/" target="_blank" rel="noopener">Documentation</a></li>
          <li><a class="dropdown-item" href="https://community.geoastra.com/tech-support/" target="_blank" rel="noopener">Support Forums</a></li>
          <li><a class="dropdown-item" href="https://community.geoastra.com/" target="_blank" rel="noopener">Blogs</a></li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Shop</a>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" href="https://gpswebshop.com/" target="_blank" rel="noopener">GPSWebShop</a></li>
          <li><a class="dropdown-item" href="https://canadagps.ca/" target="_blank" rel="noopener">Canada GPS</a></li>
        </ul>
      </li>
    </ul>

    <div class="ms-auto d-flex align-items-center">
      <div class="dropdown login-dropdown">
        <button class="btn btn-outline-dark dropdown-toggle login-menu-btn"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false">
          Login
        </button>
        <ul class="dropdown-menu dropdown-menu-end login-menu">
          <li>
            <button class="dropdown-item" type="button" (click)="loginNtripCaster()">Ntrip Caster</button>
          </li>
          <li>
            <button class="dropdown-item" type="button" (click)="loginPpkExpert()">PPK Expert</button>
          </li>
        </ul>
      </div>
    </div>
  </header>

  <!-- Level-2 product section subnav -->
  <nav class="product-subnav" *ngIf="productSubnav === 'ntrip'" aria-label="NTRIP Caster sections">
    <div class="product-subnav-inner px-4">
      <button type="button" class="subnav-link" (click)="navigateTo('ntrip-caster-section')">Overview</button>
      <button type="button" class="subnav-link" (click)="navigateTo('how-ntrip-caster-works-section')">How it works</button>
      <button type="button" class="subnav-link" (click)="navigateTo('pricing-section')">Pricing</button>
      <button type="button" class="subnav-link" (click)="navigateTo('compare-plans-section')">Compare Plans</button>
      <button type="button" class="subnav-link" (click)="navigateTo('resources-section')">Learn More</button>
      <button type="button" class="subnav-link" (click)="navigateTo('stores-section')">RTK-GNSS-Stores</button>
    </div>
  </nav>

  <nav class="product-subnav" *ngIf="productSubnav === 'analyzer'" aria-label="RTK Base Analyzer sections">
    <div class="product-subnav-inner px-4">
      <button type="button" class="subnav-link" (click)="navigateTo('rtk-base-analyzer-section')">Overview</button>
      <button type="button" class="subnav-link" (click)="navigateTo('quick-start-section')">Quick start</button>
      <button type="button" class="subnav-link" (click)="navigateTo('pricing-section')">Pricing</button>
      <button type="button" class="subnav-link" (click)="navigateTo('stores-section')">Stores</button>
    </div>
  </nav>

  <nav class="product-subnav" *ngIf="productSubnav === 'ppk'" aria-label="PPK Downloader sections">
    <div class="product-subnav-inner px-4">
      <button type="button" class="subnav-link" (click)="navigateTo('ppk-downloader-section')">Overview</button>
      <button type="button" class="subnav-link" (click)="navigateTo('quick-start-section')">Quick start</button>
      <button type="button" class="subnav-link" (click)="navigateTo('pricing-section')">Pricing</button>
      <button type="button" class="subnav-link" (click)="navigateTo('stores-section')">Stores</button>
    </div>
  </nav>

  <nav class="product-subnav" *ngIf="productSubnav === 'receivers'" aria-label="GNSS Hardware sections">
    <div class="product-subnav-inner px-4">
      <button type="button" class="subnav-link" (click)="navigateTo('receivers-overview')">Overview</button>
      <button type="button" class="subnav-link" (click)="navigateTo('receiver-x8-m1')">X8-M1</button>
      <button type="button" class="subnav-link" (click)="navigateTo('receiver-rtu609bt')">RTU609BT</button>
      <button type="button" class="subnav-link" (click)="navigateTo('receiver-rtu608bt')">RTU608BT</button>
      <button type="button" class="subnav-link" (click)="navigateTo('receiver-y55g')">Y55G</button>
      <button type="button" class="subnav-link" (click)="navigateTo('receiver-gc-9140kb')">GC-9140KB</button>
    </div>
  </nav>

  <nav class="product-subnav" *ngIf="productSubnav === 'software'" aria-label="Software and Service sections">
    <div class="product-subnav-inner px-4">
      <button type="button" class="subnav-link" (click)="navigateTo('software-overview')">Overview</button>
      <button type="button" class="subnav-link" (click)="navigateTo('software-ntrip')">NTRIP Caster</button>
      <button type="button" class="subnav-link" (click)="navigateTo('software-rtk-expert')">RTK Expert</button>
      <button type="button" class="subnav-link" (click)="navigateTo('software-ble-gnss')">BLE-GNSS iOS App</button>
    </div>
  </nav>
</div>

<!-- Offcanvas drawer for tablet/mobile -->
<div class="offcanvas offcanvas-start landing-offcanvas" tabindex="-1" id="landingNav" aria-labelledby="landingNavLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="landingNavLabel">Menu</h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <div class="accordion" id="drawerAccordion">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#accSoftware" aria-expanded="true">Software and Service</button>
        </h2>
        <div id="accSoftware" class="accordion-collapse collapse show" data-bs-parent="#drawerAccordion">
          <div class="accordion-body p-0">
            <a class="drawer-link" href="#" (click)="openNtrip(); $event.preventDefault()" data-bs-dismiss="offcanvas">NTRIP Caster</a>
            <a class="drawer-link" [href]="rtkExpertSiteUrl || 'https://rtk-expert.geoastra.com'" data-bs-dismiss="offcanvas">RTK Expert</a>
            <a class="drawer-link" href="#" (click)="openSoftwareProduct('software-ble-gnss'); $event.preventDefault()" data-bs-dismiss="offcanvas">BLE-GNSS iOS App</a>
            <a class="drawer-link" href="#" (click)="openSoftware(); $event.preventDefault()" data-bs-dismiss="offcanvas">All software and service</a>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accReceivers">GNSS Hardware</button>
        </h2>
        <div id="accReceivers" class="accordion-collapse collapse" data-bs-parent="#drawerAccordion">
          <div class="accordion-body p-0">
            <a class="drawer-link" *ngFor="let r of receiverLinks" href="#" (click)="openReceiver(r.anchor); $event.preventDefault()" data-bs-dismiss="offcanvas">{{ r.label }}</a>
            <a class="drawer-link" href="#" (click)="openReceivers(); $event.preventDefault()" data-bs-dismiss="offcanvas">All receivers</a>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accDocs">Docs</button>
        </h2>
        <div id="accDocs" class="accordion-collapse collapse" data-bs-parent="#drawerAccordion">
          <div class="accordion-body p-0">
            <a class="drawer-link" href="https://community.geoastra.com/documents/" target="_blank" rel="noopener">Documentation</a>
            <a class="drawer-link" href="https://community.geoastra.com/tech-support/" target="_blank" rel="noopener">Support Forums</a>
            <a class="drawer-link" href="https://community.geoastra.com/" target="_blank" rel="noopener">Blogs</a>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accShop">Shop</button>
        </h2>
        <div id="accShop" class="accordion-collapse collapse" data-bs-parent="#drawerAccordion">
          <div class="accordion-body p-0">
            <a class="drawer-link" href="https://gpswebshop.com/" target="_blank" rel="noopener">GPSWebShop</a>
            <a class="drawer-link" href="https://canadagps.ca/" target="_blank" rel="noopener">Canada GPS</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
